import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import LoadingScreen from "@/components/LoadingScreen";

/**
 * Strict authenticated gate. Refuses to redirect until the session has been
 * probed at least once — this is what stops the "refresh on slow 3G →
 * bounced to /login" loop.
 */
export default function ProtectedRoute({ children }) {
  const { user, initialSessionFetched } = useAuth();
  const location = useLocation();

  if (!initialSessionFetched) return <LoadingScreen label="Checking your session…" />;
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
